import * as React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import diyLightTheme = require('diy/material-ui/diyLightTheme');

export interface LoadingMaskProps extends React.Props<LoadingMask> {
    visible?: boolean;
}

export default class LoadingMask extends React.Component<LoadingMaskProps, {}> {
    render() {
        return this.props.visible ? (
            <MuiThemeProvider muiTheme={diyLightTheme}>
            <div
                style={this.getStyle()}
                data-test-id="action-in-progress-indicator"
            >
                <div style={this.getWrapperStyle()}>
                    <RefreshIndicator
                        left={0}
                        top={0}
                        status="loading"
                    />
                </div>
            </div>
            </MuiThemeProvider>
        ) : null;
    }

    private getWrapperStyle() {
        return {
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-40px"
        };
    }

    private getStyle() {
        return {
            position: "fixed",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            background: "transparent",
            zIndex: 9999999,
            cursor: 'wait'
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/LoadingMask.tsx
 **/